import type { LegalDocumentContent } from './types';

/** Canonical privacy policy for LuvLust (iOS + Android). Mirrors in-app drawer privacyScreen (en.json). */
export const privacyAppContent: LegalDocumentContent = {
  title: 'Privacy Policy',
  effectiveDate: 'Effective Date: Jan 01/2024',
  intro:
    'Welcome to LuvLust ("App"). This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our App. If you do not agree with the terms of this Privacy Policy, we request to not use the App.',
  sections: [
    {
      title: '1. Information We Collect',
      subsections: [
        {
          title: 'a. Personal Information',
          content:
            'We do not collect personally identifiable information unless explicitly provided by you (e.g., when contacting us for support).',
        },
        {
          title: 'b. Non-Personal Information',
          content:
            "We may collect non-personal information, such as device type, operating system, and usage statistics, to improve the App's performance and user experience.",
        },
      ],
    },
    {
      title: '2. How We Use Your Information',
      paragraphs: ['We use the collected information to:'],
      listItems: [
        'Improve and personalize the App',
        'Monitor and analyze trends and usage',
        'Fix bugs and enhance security',
        'Respond to support requests',
      ],
    },
    {
      title: '3. Third-Party Services',
      paragraphs: [
        'Our App may use third-party services such as analytics providers and advertising networks. These services may collect information based on your interactions with the App. We encourage you to review their respective privacy policies.',
      ],
    },
    {
      title: '4. Data Retention',
      paragraphs: [
        'We retain collected data only for as long as necessary to fulfill the purposes outlined in this Privacy Policy. Non-personal information may be retained indefinitely for analytics and performance monitoring.',
      ],
    },
    {
      title: '5. Security',
      paragraphs: [
        'We take reasonable measures to protect your information from unauthorized access, alteration, or disclosure.',
      ],
    },
    {
      title: "6. Children's Privacy",
      paragraphs: [
        'Our App is not intended for children under the age of 13. We do not knowingly collect personal information from children. If you believe a child has provided us with personal data, please contact us. If you are under the age of 13, please do not use the app.',
      ],
    },
    {
      title: '7. Changes to This Privacy Policy',
      paragraphs: [
        'We may update this Privacy Policy from time to time. Any changes will be posted within the App. Your continued use of the App after such changes constitutes your acceptance of the updated policy.',
      ],
    },
    {
      title: '8. Contact Us',
      paragraphs: [
        'If you have any questions or concerns regarding this Privacy Policy, please contact us at:',
        'starlitapps.dev@gmail.com',
      ],
    },
  ],
  consent: 'By using LuvLust, you consent to this Privacy Policy.',
};
